
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";

const ArcHistogramStep = (props) => {
    // ChartJS.register(ArcElement, Tooltip, Legend);
    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, MaxValue, Label, Step, Color } = ComponentProperties

    const DataReportData = props.DataReportData

    const initSteps = Array.apply(null, Array(Math.floor(MaxValue / Step))).map(function (x, i) { return i; })
    const Distributed = initSteps.map((s, si) => { return DataReportData.filter(dr => { return Number(dr[KeyToUse]) >= s * Step && Number(dr[KeyToUse]) <= (s * Step + Step) }).length })
    const Labels = initSteps.map((s) => { return String(s * Step) + "-" + String(s * Step + Step) })
    const labelCenter = {
        id: "labelCenter",
        afterDraw: (chart, args, options) => {
            if (!Array.isArray(options.labels)) {
                return console.error('"options.lables" must be array', options.lables);
            }

            const {
                ctx,
                chartArea: { width, height }
            } = chart;
            const context = ctx.canvas.getContext("2d");
            context.save();

            const labels = options.labels.slice();
            const totalFontSize = labels.reduce((x, y, index) => {
                let prevSize = x[index - 1] || 0;
                x.push(prevSize + y.font.size);
                return x;
            }, []);
            labels.forEach((label, index) => {
                let textPosition = totalFontSize[index] - label.font.size + 10;
                const values = {
                    text: label.text || "?",
                    font: {
                        size: label.font.size || 30,
                        family: label.font.family || "sans-serif",
                        color: label.font.color || "black",
                        style: label.font.style || "normal",
                        unit: label.font.unit || "px"
                    }
                };
                switch (values.font.unit) {
                    case "em":
                        values.font.size = label.font.size * 0.15;
                        textPosition *= 1.1;
                        break;
                    default:
                        break;
                }

                context.font = `${values.font.style} ${values.font.size}${values.font.unit} ${values.font.family}`;
                context.textAlign = "center";
                context.fillStyle = values.font.color;
                context.fillText(values.text, width / 2 + textPosition, height / 2 + textPosition);
            });
            context.restore();
        }
    };

    const ArcSumOfValues = _.sumBy(DataReportData, item => Number(item[KeyToUse]))

    const ArcFinalValue = Math.trunc(ArcSumOfValues / (DataReportData && DataReportData.length || 1))

    const data = {
        labels: Labels,
        datasets: [
            {
                data: Distributed,
                backgroundColor: initSteps.map(x => { return GetColor(Color, x * Step) + "AA" }),
            },
        ],
    }
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {

                grid: {
                    display: false,
                    drawBorder: false
                },
                ticks: {
                    display: false
                }
            },
            x: {
                grid: {
                    display: false,
                    drawBorder: false
                },
                ticks: {
                    display: false
                }
            }
        },
        plugins: {
            legend: {
                display: false
            },
            labelCenter: {
                labels: [
                    {
                        text: ArcFinalValue,
                        font: {
                            size: 3.25,
                            unit: "rem",
                            color: 'black'
                        }
                    }
                ]
            }

        }

    }

    const plugins = [labelCenter]

    return (
        <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h6" align="center">{Label}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Bar data={data} options={options} plugins={plugins} />
            </Grid>
        </Grid>
    )

}

export default ArcHistogramStep